var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9495 1.48938C48.9706 1.16928 51.0294 1.16928 53.0505 1.48938L62.2439 2.94548C64.265 3.26559 66.2231 3.9018 68.0463 4.83078L76.3398 9.05655C78.1631 9.98553 79.8287 11.1957 81.2756 12.6426L87.8574 19.2244C89.3043 20.6713 90.5145 22.3369 91.4435 24.1602L95.6692 32.4537C96.5982 34.2769 97.2344 36.235 97.5545 38.2561L99.0106 47.4495C99.3307 49.4706 99.3307 51.5294 99.0106 53.5505L97.5545 62.7439C97.2344 64.765 96.5982 66.7231 95.6692 68.5463L91.4435 76.8398C90.5145 78.6631 89.3043 80.3287 87.8574 81.7756L81.2756 88.3574C79.8287 89.8043 78.1631 91.0145 76.3398 91.9435L68.0463 96.1692C66.2231 97.0982 64.265 97.7344 62.2439 98.0545L53.0505 99.5106C51.0294 99.8307 48.9706 99.8307 46.9495 99.5106L37.7561 98.0545C35.735 97.7344 33.7769 97.0982 31.9537 96.1692L23.6602 91.9435C21.8369 91.0145 20.1713 89.8043 18.7244 88.3574L12.1426 81.7756C10.6957 80.3287 9.48553 78.6631 8.55655 76.8398L4.33078 68.5463C3.4018 66.7231 2.76559 64.765 2.44548 62.7439L0.989379 53.5505C0.669276 51.5294 0.669277 49.4706 0.98938 47.4495L2.44548 38.2561C2.76559 36.235 3.4018 34.2769 4.33078 32.4537L8.55655 24.1602C9.48553 22.3369 10.6957 20.6713 12.1426 19.2244L18.7244 12.6426C20.1713 11.1957 21.8369 9.98553 23.6602 9.05655L31.9537 4.83078C33.7769 3.9018 35.735 3.26559 37.7561 2.94548L46.9495 1.48938Z",
    fill: "#E3E9EC",
    stroke: "#AABDC5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6226_27627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 25.8569C54.7751 25.8569 59.4428 27.2729 63.4131 29.9257C67.3834 32.5786 70.4778 36.3492 72.3051 40.7607C74.1325 45.1722 74.6106 50.0266 73.679 54.7098C72.7475 59.3931 70.4481 63.6949 67.0716 67.0714C63.6952 70.4478 59.3933 72.7472 54.7101 73.6787C50.0268 74.6103 45.1725 74.1322 40.761 72.3049C36.3494 70.4776 32.5789 67.3831 29.926 63.4128C27.2731 59.4426 25.8572 54.7748 25.8572 49.9998C25.8495 43.0837 28.5105 36.4313 33.2858 31.4284",
    stroke: "#00525D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8572 33.2854L33.2857 31.4282L35.1429 38.8568M50 36.9997V51.8568L59.6572 56.6854",
    stroke: "#00525D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6226_27627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pendingIcon.dedc753d73b402e0d7bd0c7257fbc363.svg";
export { ForwardRef as ReactComponent };